<template>
  <div
    v-if="value"
    class="dateRange"
  >
    <template v-if="dateRangeValid">
      <a-range-picker
        v-if="startDate !== null && endDate !== null"
        :default-value="[startDate, endDate]"
        :format="dateTimeFormat"
        :value="[startDate, endDate]"
        disabled
      />
      <span v-if="fullDay">
        <a-divider type="vertical"/>
        {{ $t(`_.fullDay`) }}
      </span>
      <div
        v-if="options.select_weekdays"
        class="daySelector"
      >
        <a-checkbox-group
          :options="daySelector"
          :value="weekdays"
          disabled
        />
      </div>
    </template>
    <template v-else>
      {{ $t('_.no_data') }}
    </template>
  </div>
</template>

<script>
import FieldViewer from '@/components/fields/FieldViewer'
import moment from 'moment-timezone'

export default {
  name: 'FieldViewerDateRange',
  extends: FieldViewer,
  data () {
    return {
      dateTimeFormat: '',
      daySelector: [
        { label: 'Mo', value: 1 },
        { label: 'Tu', value: 2 },
        { label: 'We', value: 3 },
        { label: 'Th', value: 4 },
        { label: 'Fr', value: 5 },
        { label: 'Sa', value: 6 },
        { label: 'Su', value: 7 },
      ],
      endDate: moment(),
      fullDay: false,
      startDate: moment(),
      weekdays: [],
    }
  },
  computed: {
    dateRangeValid () {
      let dateRange = this.value
      return (dateRange.start !== null && dateRange.end !== null) && dateRange.length !== 0
    },
  },
  watch: {
    value () {
      this.parseDateRange()
    },
  },
  mounted () {
    this.parseDateRange()
  },
  methods: {
    parseDateRange () {
      let dateRange = this.value
      this.dateTimeFormat = (this.options.date_time_format ? this.options.date_time_format : 'YYYY-MM-DD HH:mm')
      if (dateRange) {
        if (this.dateRangeValid) {
          this.startDate = moment.utc(dateRange.start, this.dateTimeFormat).tz(moment.tz.guess())
          this.endDate = moment.utc(dateRange.end, this.dateTimeFormat).tz(moment.tz.guess())
        } else {
          this.startDate = null
          this.endDate = null
        }
        this.weekdays = dateRange.weekdays
        this.fullDay = dateRange.fullDay
      }
    },
  },
}
</script>

<style>
.daySelector {
  padding-top: 8px;
}

.daySelector .ant-checkbox-group {
  display: flex;
  justify-content: space-around;
  padding: 4px;
}

.daySelector .ant-checkbox-wrapper {
  display: flex;
  flex-direction: column;
}

.daySelector .ant-checkbox-wrapper span {
  padding: 0;
}

.daySelector .ant-checkbox-disabled + span {
  color: inherit;
}
</style>
